import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "result-game-skip-game t-text" }
const _hoisted_2 = ["innerHTML"]

import { marked } from 'marked'

export default /*@__PURE__*/_defineComponent({
  __name: 'CResultGameSkipGame',
  emits: ['contact-customer-service'],
  setup(__props, { emit: __emit }) {

const emit = __emit

function md(text: string): string {
  return marked(text)
}
function customer(e: Event) {
  const event: any = e
  if (event.target && event.target.tagName === 'A' && event.target.href) {
    if (/#customerservice/.test(event.target.href)) {
      emit('contact-customer-service')
    }
  }
  e.preventDefault()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('resultView.gameSkipped.headline')), 1),
    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icf-alert alert-icon" }, null, -1)),
    _createElementVNode("div", {
      onClick: customer,
      innerHTML: md(_ctx.$t('resultView.gameSkipped.details'))
    }, null, 8, _hoisted_2)
  ]))
}
}

})